<header
    class="fixed top-0 right-0 left-0 z-50 px-6 w-full transition-all duration-500 ease-in-out xl:px-0"
    [ngClass]="{
        'shadow-md': isSticky,
    }"
    [style.backgroundColor]="'var(--pax-header-background)'"
    [style.transform]="isSticky ? 'translateY(0)' : 'translateY(0)'"
>
    <div class="py-8 transition-all duration-500 ease-in-out" [ngClass]="{ 'py-6': isSticky }">
        <div class="flex gap-12 justify-start items-center mx-auto max-w-7xl">
            <!-- Main Navigation -->
            @if (showNavigation()) {
                <nav>
                    <ul class="flex gap-8">
                        @for (item of navigationItems(); track item.path) {
                            <li>
                                <a
                                    [routerLink]="item.path"
                                    routerLinkActive="border-b-2 pb-2"
                                    [routerLinkActiveOptions]="item.exact ? { exact: true } : { exact: false }"
                                    class="font-medium text-[var(--pax-header-text-color)] border-[var(--pax-header-nav-underline-color)] hover:text-[var(--pax-header-text-color-hover)] hover:border-[var(--pax-header-nav-underline-color-hover)]"
                                >
                                    {{ item.label }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            }

            <!-- Logo -->
            <div class="flex items-center ml-auto">
                <img src="/assets/logo.svg" alt="Pax Logo" class="transition-all duration-500 ease-in-out" [ngClass]="{ 'h-8': isSticky, 'h-12': !isSticky }" />
            </div>
        </div>
    </div>
</header>

<!-- spacer to prevent content jump -->
<div class="transition-none" [style.backgroundColor]="'var(--pax-header-background)'" [style.height]="'112px'"></div>
